export default "__VITE_ASSET__BXwJgr4X__"